/**
 * Main App Component
 *
 * Sets up:
 * - React Router
 * - Auth Context
 * - Protected routes
 * - Layout wrapper
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Layout } from '@/components/Layout/Layout';

import { Auth } from '@/pages/Auth';
import { About } from '@/pages/About';
import { GymTracker } from '@/pages/GymTracker';
import { Schedule } from '@/pages/Schedule';
import { Notes } from '@/pages/Notes';
import { Analytics } from '@/pages/Analytics';
import { Settings } from '@/pages/Settings';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Auth />} />
          <Route path="/about" element={<About />} />

          {/* Protected routes */}
          <Route
            path="/gym"
            element={
              <ProtectedRoute>
                <Layout>
                  <GymTracker />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/schedule"
            element={
              <ProtectedRoute>
                <Layout>
                  <Schedule />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/notes"
            element={
              <ProtectedRoute>
                <Layout>
                  <Notes />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Layout>
                  <Analytics />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/gym" replace />} />
          <Route path="*" element={<Navigate to="/gym" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
